import {
  Button,
  Checkbox,
  FormControlLabel,
  FormGroup,
  Grid,
  TextField,
} from '@material-ui/core'
import { createStyles, makeStyles } from '@material-ui/core/styles'
import React, { FC, useState } from 'react'

import {
  fieldError,
  fieldErrorText,
  nextDisabled,
  PardotFormProps,
} from '../../utils/form/useForm'
import { ButtonLoadingSpinner } from '../UI/Button/Button'
import SectionWrapper, { SectionWrapperProps } from './SectionWrapper'
import { CenterContainer } from './styles'

interface StepThreeProps extends SectionWrapperProps {
  form: PardotFormProps
  handlePrev: () => void
  trainingInterestsLabel?: string
  gdprLabel?: string
  submitText?: string
  GDPRCountryPermission?: boolean
}

const useStyles = makeStyles((theme) =>
  createStyles({
    textArea: {
      marginBottom: 24,
    },
    gdprConsent: {
      marginBottom: 20,

      '&.MuiFormControlLabel-root': {
        alignItems: 'flex-start',
      },
    },
    buttonContainer: {
      marginTop: 'auto',
      '& #stepFormSubmitButton': {
        width: '205px',
      },
      [theme.breakpoints.down('xs')]: {
        justifyContent: 'center',
        '& button': {
          margin: '8px 8px 0',
        },
      },
    },
    button: {
      backgroundColor: '#E9B265',
      fontWeight: 'bold',
      color: 'white',
      '&::placeholder': {
        color: '#E9B265',
      },
      '&:disabled': {
        backgroundColor: '#E9B265',
      },
    },
  }),
)

const StepThree: FC<StepThreeProps> = ({
  form,
  form: { values, errors, handleChange, isSubmitting },
  headline,
  handlePrev,
  GDPRCountryPermission,
  trainingInterestsLabel,
  gdprLabel,
  submitText,
  currentSlide,
}) => {
  const classes = useStyles()
  const [didShowGDPRConsent, setDidShowGDPRConsent] = useState(false)

  return (
    <CenterContainer>
      <SectionWrapper currentSlide={currentSlide} headline={headline}>
        <TextField
          className={classes.textArea}
          disabled={currentSlide !== 2}
          error={fieldError(form, 'trainingInterests')}
          helperText={fieldErrorText(form, 'trainingInterests')}
          id="trainingInterests"
          label={trainingInterestsLabel}
          multiline
          name="trainingInterests"
          onChange={handleChange}
          value={values.trainingInterests}
          variant="filled"
        />
        {didShowGDPRConsent || GDPRCountryPermission ? (
          <FormGroup className={classes.gdprConsent}>
            <FormControlLabel
              control={
                <Checkbox
                  id="GDPRConsent"
                  name="GDPRConsent"
                  onChange={handleChange}
                  onClick={() => setDidShowGDPRConsent(true)}
                  value={values.GDPRConsent}
                />
              }
              label={gdprLabel}
            />
            {fieldError(form, 'GDPRConsent') ? (
              <span className="errorText">{errors.GDPRConsent}</span>
            ) : null}
          </FormGroup>
        ) : null}
        <Grid
          className={classes.buttonContainer}
          container
          item
          justifyContent="space-between"
        >
          <Button
            className={classes.button}
            disableElevation
            disabled={currentSlide !== 2}
            onClick={handlePrev}
            variant="contained"
          >
            {'<'} Back
          </Button>
          <Button
            className={classes.button}
            disableElevation
            disabled={nextDisabled(form) || isSubmitting}
            type="submit"
            variant="contained"
          >
            {isSubmitting ? <ButtonLoadingSpinner /> : submitText}
          </Button>
        </Grid>
      </SectionWrapper>
    </CenterContainer>
  )
}

export default StepThree
